<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import BroadcastInfoPanel from '../../../../../../broadcasts/components/panels/BroadcastInfoPanel.vue'
import { Broadcast } from '../../../../../../broadcasts/models/broadcast'
import { SiteID } from '../../../../../../sites/models/site'

definePage({
  props: true,
  meta: {
    requiresAuth: true,
    requiresOrganisation: true,
    hideLeftColumn: true,
    hideRightColumn: true,
  },
})

const { siteId, broadcast } = defineProps<{
  siteId: SiteID
  broadcast: Broadcast
}>()
</script>

<template>
  <BroadcastInfoPanel :site-id="siteId" :broadcast="broadcast" />
</template>
